<template>
    <div class="ec-bike-listing-filters-button col-xs-5 col-sm-4 col-md-3 col-lg-2" @click="onClick">
        Filtres
        <i class="glyphicon glyphicon-chevron-down pull-right" v-if="!filtersOpen"></i>
        <i class="ec-icon ec-icon-cross pull-right ec-close-filters ec-spin" v-if="filtersOpen"></i>
    </div>
</template>

<style lang="scss" type="text/scss">
    @import "../../../sass/variables";
    @import "../../../sass/mixins";

    .ec-bike-listing-filters-button {
        @include ec-bike-listing-button();

        padding: $grid-gutter-width/4 $grid-gutter-width $grid-gutter-width/4 $ec-bike-listing-controls-padding;
        background: $ec-primary-color;
        color: $ec-primary-color-light;
        font-size: $ec-font-size-large;

        @include transition(color 0.3s ease);

        &:hover {
            color: $ec-color-white;
        }

        .ec-close-filters {
            font-size: $ec-icon-height-small;
            margin-top: 2px;
        }

        @media (max-width: $screen-xs-max) {
            padding-left: $ec-bike-listing-controls-padding-xs;
        }
    }
</style>

<script type="text/babel">
    export default {
        props: ['filtersOpen'],

        methods: {
            onClick: function () {
                this.$emit('click');
            }
        }
    }
</script>